export default __webpack_public_path__ + "static/media/012-popcorn.345d10b3.svg";